import { getDictionaryByKeys } from "@/api/index";
// import router from "@/router/index";
// import { blankRoute, dynamicRoutes, mainContainer } from "@/router/routers";
// import { getUserPermissionMap, recursionRoutes } from "@/utils/auth";

export default {
  namespaces: true,
  state: {
    get token () {
      return localStorage.getItem("tokenweb");
    },
    set token (value) {
      localStorage.setItem("tokenweb", value);
    },
    get userInfoweb () {
      const info = localStorage.getItem("userInfoweb");
      return info ? JSON.parse(info) : {};
    },
    set userInfoweb (value) {
      localStorage.setItem("userInfoweb", value);
    },
    asyncMenuList: [],
    msgData: null,
    permissionList: null,

    dictionaryValues: {}, // 数据字典
    get route () {
      return sessionStorage.getItem('route')
    },
    set route (value) {
      sessionStorage.setItem('route', value)
    },
  },
  mutations: {
    DELETE_PERMISSION_LIST (state) {
      state.permissionList = null;
    },
    SET_USER_INFO (state, data) {
      state.userInfoweb = data;
    },
    SET_TOKEN (state, data) {
      state.token = data;
    },
    SET_ASYNC_MENU_LIST (state, data) {
      state.asyncMenuList = data;
    },
    SET_MSG_DATA (state, data) {
      state.msgData = data;
    },
    SET_DICTIONARY_KEYS (state, { key, data }) {
      state.dictionaryValues[key] = data;
    },
    SET_ROUTE (state, data) {
      state.route = data
    },
    
  },
  actions: {
    setToken ({ commit }, data) {
      commit("SET_TOKEN", data);
    },
    setUserInfo ({ commit }, data) {
      commit("SET_USER_INFO", data);
    },
    setRoute ({ commit }, data) {
      commit('SET_ROUTE', data)
    },
    logout ({ commit }) {
      commit("SET_TOKEN", "");
      commit("SET_USER_INFO", "");
      commit('SET_ROUTE', '')
    },
    setMsgData ({ commit }, data) {
      commit("SET_MSG_DATA", data);
    },
    deletePermissionList ({ commit }, data) {
      commit("DELETE_PERMISSION_LIST", data);
    },
    GET_KEY_VALUES ({ commit }, keys) {
      return getDictionaryByKeys(keys).then((res) => {
        const data = res.data;
        for (const key in data) {
          if (data[key].children) {
            commit("SET_DICTIONARY_KEYS", { key, data: data[key].children });
          }
        }
        return res;
      });
    },
  },
};
